import { createFileRoute, redirect } from '@tanstack/react-router'

import { ACTIONS, LABELS } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute('/_protected/$tenantKey/tour-import-jobs')(
  {
    meta: () => [{ title: `${LABELS.TOUR}${ACTIONS.IMPORT}${LABELS.HISTORY}` }],
    beforeLoad: ({ context: { auth } }) => {
      if (auth.user.type !== USER_TYPE.OWNER) {
        throw redirect({
          to: `/${getDefaultUserMeTenant(auth.user).key}`
        })
      }
    }
  }
)
